import React, { useState } from "react";
import CustomModal from "../../../../shared/components/CustomModal/CustomModal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { allSharedComponents } from "../../../../shared";
import CompetitionsFeedbackForm from "./CompetitionFeedbackForm";

function CompetitionsFeedback() {
  const { BaseForm, NavBar } =
    allSharedComponents;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isShow, setShow] = useState(true);
  const onSetShow = () => {
    setShow((prev) => !prev);
  };
  
  return (
    <>
      <div className="background-image">
        <CustomModal
          size="lg"
          show={isShow}
          scrollable={true}
          setShow={onSetShow}
          isMoveToWP={true}
        >
          <BaseForm>
            <CompetitionsFeedbackForm setShow={setShow} />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
}

export default CompetitionsFeedback;
